<template>
  <div class="live-comment-wrapper">
    <div class="textarea">
      <EditTextarea ref="textarea" :limit="200" :placeholder="placeholder"></EditTextarea>
    </div>
    <div class="toolbar">
      <div class="left">
        <FaceBtn class="tool-btn" @click="addFace" ref="faceBtn" title="添加表情"></FaceBtn>
        <ImgBtn class="tool-btn" @click="addImg" title="添加图片" v-if="enablePicture"></ImgBtn>
        <AtBtn class="tool-btn" @click="at" ref="atBtn" title="@好友" v-if="enableAt"></AtBtn>
      </div>
      <div class="right">
        <el-checkbox class="tool-btn" v-model="onTop" v-if="enableOnTop">置顶评论</el-checkbox>
        <el-button size="mini" type="primary" @click="submit" :loading="submitFlag">发表</el-button>
      </div>

    </div>
    <div class="img-list" v-show="uploadImgShow">
      <UploadImg
        ref="uploadComponent"
        :uploadOption="ossUploadOption"
        :countLimit="1"
        :customStyle="{'width': '85px', 'height': '85px'}"
        :isAvatarMode="false"
        :isChange="true"
        :autoUpload="false"
      ></UploadImg>
    </div>
  </div>
</template>

<script>
    import faceBus from "../../js/bus/faceBus";
    import chooseFriendBus from "../../js/bus/chooseFriendBus";
    import setting from "../../config/setting";
    import {uuid} from "../../js/utils/uuid";
    import EditTextarea from '../baseComponent/EditTextarea'
    import FaceBtn from '../iconBtn/FaceBtn'
    import AtBtn from '../iconBtn/AtBtn'
    import ImgBtn from '../iconBtn/ImgBtn'
    import UploadImg from "./UploadImg.vue"

    export default {
        name: "CommentEditor",
        components:  {EditTextarea, FaceBtn, AtBtn, ImgBtn, UploadImg},
        props: {
            placeholder: {
                type: String,
                required: false
            },
            //启用添加图片
            enablePicture: {
                type: Boolean,
                default: true
            },
            //启用艾特好友
            enableAt: {
                type: Boolean,
                default: true
            },
            //启用置顶评论选择
            enableOnTop: {
                type: Boolean,
                default: false
            },
            //提交标志
            submitFlag: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                faceId: uuid(),
                atId: uuid(),
                onTop: false,
                ossUploadOption: setting.ossUploadOption1,
                uploadImgShow: false,
            }
        },
        created() {
            //监听表情选择回调
            faceBus.onCallback(this.faceId, (faceItem) => {
                this.$refs.textarea.addFace(faceItem);
            });
            //监听@回调
            chooseFriendBus.onCallback(this.atId, (uList) => {
                for (let i = 0; i < uList.length; i++) {
                    this.$refs.textarea.addAt(uList[i]);
                }
            });
        },
        methods: {
            focus() {
                this.$refs.textarea.focus();
            },
            /**
             * submit提交事件:function submit(content:string, pictures:array, onTop:Boolean)
             */
            submit() {
                this.$refs.uploadComponent.manualUpload().then((pathList) => {
                    this.$emit("submit", this.$refs.textarea.getContent(), pathList, this.onTop)
                })
            },
            addFace() {
                faceBus.show(this.faceId, this.$refs.faceBtn.$el.getBoundingClientRect());
            },
            addImg() {
                if (this.uploadImgShow) {
                    this.$refs.uploadComponent.clean();
                    this.uploadImgShow = false;
                } else {
                    this.uploadImgShow = true;
                }
            },
            at() {
                chooseFriendBus.show(this.atId, this.$refs.atBtn.$el.getBoundingClientRect());
            },
            clean() {
                this.$refs.textarea.clean();
                this.$refs.uploadComponent.clean();
                this.uploadImgShow = false;
                this.onTop = false;
            }
        }
    }
</script>

<style scoped>
  .textarea{
    border: 2px #c7e5eb solid;
    border-radius: 2px;
    margin-bottom: 5px;
  }


  .toolbar{
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .toolbar .left {
    display: flex;
    align-items: center;
  }

  .tool-btn {
    margin-right: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/view/component/CommentEditor.vue